import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Submission } from 'src/types/shared/Assessments';

export const fetchSubmissionsForChallengeRequest = createAction(
    'fetchSubmissionsForChallengeRequest',
);
export const fetchSubmissionsForChallengeSuccess = createAction<Submission[]>(
    'fetchSubmissionsForChallengeSuccess',
);
export const fetchSubmissionsForChallengeFailure = createAction(
    'fetchSubmissionsForChallengeFailure',
);

export const fetchSubmissionsForChallenge = (challengeID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSubmissionsForChallengeRequest());
    try {
        const { data } = await api.get<Submission[]>(
            `admin/challengeapplications/challenge/${challengeID}`,
        );

        dispatch(fetchSubmissionsForChallengeSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSubmissionsForChallengeFailure, e as any);
    }
};
